// extracted by mini-css-extract-plugin
export default {"adminWrapper":"AdminLayout_adminWrapper__KyIo9","withSidebar":"AdminLayout_withSidebar__85kh0","fullContent":"AdminLayout_fullContent__DK7do"};